import React from 'react';

import { Text } from '../../../../typography/text/Text';
import styles from '../CartItem.module.scss';

const ProductOption = ({
  label,
  color,
  capitalize,
  className,
  labelClassName,
}) => {
  return (
    <Text
      as="span"
      align="start"
      className={`${styles.productOption} ${className}`}
    >
      {label && (
        <>
          <span className={labelClassName}>{label}</span>:{' '}
        </>
      )}
      {`${capitalize ? capitalize(color) : color}`}
    </Text>
  );
};

export default ProductOption;
